import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { Redirect } from "react-router";
import PageContent from "@my-dld/components/PageContent";
import { extractPropInfo } from "../MyDLD/PropertyDetails";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { getAppServices } from "@10x/coreapp";

interface Props extends RoutedViewProps<{ propertyTypeId: string; propertyId: string; reference: string }> {

}

interface State {
	property: AssetCard;
	reference: string;
}

class MollakServiceChargeSuccess extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		let property = props.location.state ? props.location.state.property : undefined;
		const { propertyTypeId, propertyId, reference } = props.match.params;
		if ( !property ) {
			let type = Number( propertyTypeId );
			let id = Number( propertyId );
			let assetCards = getAppServices().storeService.getStore().getState().UserData.properties;
			if ( assetCards ) {
				property = assetCards.find( ( p: AssetCard ) => {
					return p.propertyId === id && p.propertyTypeId === type;
				} );
			}
		}
		this.state = {
			property: property,
			reference: reference,
		};
	}

	render() {
		const { property, reference } = this.state;
		if ( property == null )
			return <Redirect to={ "/mydld" }/>;
		const { val, lbl } = extractPropInfo( property );
		return <PageContent
			title={ `${ Strings.mollak_service_charges } - ${ lbl } : ${ val }` }
			hideQLinks={ true }>
			<PageTitle title={ Strings.mollak_service_charges } paths={ [ DashboardBCItem ] }/>
			<React.Fragment>
				<div className="success-msg" id="successMsg" style={ { marginTop: "46px" } }>
					<div className="col-md-12 text-center">
						<div className="mb-3 d-flex justify-content-center green">
							<div className="svg-check-icon"/>
						</div>
						<p>{ Strings.mollak_payment_success }</p>
						<br/>
						<div className="refn-box">
							{ Strings.payment_ref_number }: <span>{ reference }</span>
						</div>
						<br/>
						<button
							onClick={ this.navigateBack }
							className="btn btn_1 btn_style1">{ Strings.back }</button>
					</div>
				</div>
			</React.Fragment>
		</PageContent>;
	}

	private navigateBack = () => {
		this.props.history.goBack();
	};
}

export default MollakServiceChargeSuccess;
